module.exports = __webpack_public_path__ + "img/custom_card_img1.dfab70aa.png";